import React, { Fragment } from 'react';

import { formatPhoneNumber } from '@usas/ui-web/utils/validation';
import DatePicker from '@usas/ui-web/components/datepickers/DatePicker';
import Input from '@usas/ui-web/components/inputs/Input';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import InternationalPhoneInput from '@usas/ui-web/components/inputs/InternationalPhoneInput';
import OrgRoleStaffRoleTreeView from '@usas/ui-web/components/tree/orgRoleTree/OrgRoleStaffRoleTreeView';

const PreCompLocationStaffForm = ({ formState, errorState, onFormValueChanged, onStaffRoleChanged, PRECOMP_STAFF_ROLE_GROUP_ID }) => (
  <Fragment>
    <div className="row">
      <div className="col-xs-12 col-sm-6 col-md-4">
        {onFormValueChanged === undefined
          ? <ReadOnly
            label="First Name"
            name="firstName"
            value={formState.firstName} />
          : (
            <Input
              label="First Name*"
              name="firstName"
              value={formState.firstName}
              error={errorState.firstName}
              message={errorState.firstName}
              onChange={(value) => { onFormValueChanged('firstName', value); }} />
          )
        }
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        {onFormValueChanged === undefined
          ? <ReadOnly
            label="Last Name"
            name="lastName"
            value={formState.lastName} />
          : (
            <Input
              label="Last Name*"
              name="lastName"
              value={formState.lastName}
              error={errorState.lastName}
              message={errorState.lastName}
              onChange={(value) => { onFormValueChanged('lastName', value); }} />
          )
        }
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        {onFormValueChanged === undefined
          ? <ReadOnly
            label="Phone Number"
            name="phoneNumber"
            value={formatPhoneNumber(formState.phoneNumber)} />
          : (
            <InternationalPhoneInput
              label="Phone Number*"
              name="phoneNumber"
              value={formState.phoneNumber}
              error={errorState.phoneNumber}
              message={errorState.phoneNumber}
              onChange={(value) => { onFormValueChanged('phoneNumber', value); }} />
          )
        }
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        {onFormValueChanged === undefined
          ? <ReadOnly
            label="Email"
            name="email"
            value={formState.email} />
          : (
            <Input
              label="Email*"
              name="email"
              value={formState.email}
              error={errorState.email}
              message={errorState.email}
              onChange={(value) => { onFormValueChanged('email', value); }} />
          )
        }
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        {onFormValueChanged === undefined
          ? <ReadOnly
            label="Birth Date"
            name="birthDate"
            value={formState.birthDate} />
          : (
            <DatePicker
              label="Birth Date*"
              name="birthDate"
              value={formState.birthDate}
              error={errorState.birthDate}
              message={errorState.birthDate}
              onChange={(value) => { onFormValueChanged('birthDate', value); }} />
          )
        }
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        {onStaffRoleChanged === undefined
          ? <ReadOnly
            label="Staff Role(s)"
            name="orgRolesId"
            value={formState.orgRolesId.map(r => `${r.name}/`)} />
          : (
            <OrgRoleStaffRoleTreeView
              label="Staff Role(s)*"
              name="orgRolesId"
              value={formState.orgRolesId}
              error={errorState.orgRolesId}
              message={errorState.orgRolesId}
              singleSelect={false}
              onChange={(value) => { onStaffRoleChanged('orgRolesId', value) }}
              roleGroupId={PRECOMP_STAFF_ROLE_GROUP_ID}
            />
          )
        }
      </div>
    </div>
  </Fragment>
);

export default PreCompLocationStaffForm;